export default "__VITE_ASSET__CyHvlgXH__"